import { MdOutlineCurrencyRupee } from "react-icons/md";

import './index.css'

const Posts = () => (
    <>
    <div className='post-items'>
        <span className='order-id'>#28109</span>
        <span className='order-date'>7 July, 2023</span>
        <span className='order-amount'><MdOutlineCurrencyRupee />1,278.23</span>
        <span className="order-fee"><MdOutlineCurrencyRupee />22</span>
    </div>
    <hr className="line" />
    </>
)

export default Posts
